import React from 'react'
import logo from '../../../assets/static/logo-rapidoribeiraopreto.png'

const LogotipoRapidoRibeiraoPreto = () => (
	<img src={logo} alt="Logotipo Rápido Ribeirão Preto" />
)

export default LogotipoRapidoRibeiraoPreto
